<template>
  <div class="warp_contrainer">
    <div class="search_container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="待入库" name="8"> </el-tab-pane>
        <el-tab-pane label="已入库" name="9"></el-tab-pane>
        <el-tab-pane label="已出库" name="4"></el-tab-pane>
      </el-tabs>

      <el-form :inline="true" v-if="activeName != 8">
        <div style="margin: 10px 0">
          <el-row>
            <el-col>
              <el-form-item label="">
                <el-input
                  v-model="search.orderNo"
                  style="width: 150px"
                  placeholder="运单号/订单号"
                  clearable
                  @clear="init()"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="search.userName"
                  style="width: 150px"
                  placeholder="用户名/vip号"
                  clearable
                  @clear="init()"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="search.orderNumber"
                  style="width: 170px"
                  placeholder="订单号"
                  clearable
                  @clear="init()"
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="search.batchNum"
                  style="width: 255px; padding-right: 6px"
                  remote
                  @change="batchChange"
                  @clear="clearChecked"
                  :remote-method="remoteMethod"
                  reserve-keyword
                  filterable
                  :loading="loading"
                  clearable
                  placeholder="请输入批次"
                >
                  <el-option
                    v-for="item in batchList"
                    :key="item.sendId"
                    :label="item.remark"
                    :value="item.remark"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="search.goodType"
                  clearable
                  placeholder="货物类型"
                  @change="init()"
                  @clear="init()"
                  style="width: 150px"
                >
                  <el-option
                    v-for="item in goodTypeSelect"
                    :key="item.goodType"
                    :label="item.goodName"
                    :value="item.goodType"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="checkedRecStatus"
                  clearable
                  @change="init()"
                  placeholder="签收状态"
                  style="width: 120px"
                >
                  <el-option
                    v-for="item in receOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="出库时间" v-show="activeName == '4'">
                <el-date-picker
                  v-model="chukuTime"
                  type="daterange"
                  @change="getDate(chukuTime)"
                  range-separator="至"
                  clearable
                  @clear="init()"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button
                  style="margin-left: 20px"
                  @click="init()"
                  type="primary"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  v-show="activeName == '4'"
                  @click="exportToExcel()"
                  >导出Excel
                </el-button>
                <el-button
                  @click="bookTip = true"
                  type="primary"
                  v-show="false"
                  >开放预约
                </el-button>
              </el-form-item>

              <el-form-item v-show="activeName == '4'">
                <button class="totalFeeBtn">
                  <div class="totalFee">
                    总运费:<span>{{ totalFee }}</span>
                  </div>
                </button>
                <button class="totalFeeBtn">
                  <div class="totalFee">
                    用户人数:<span>{{ totalNum }}</span>
                  </div>
                </button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <!-- //表格 -->
    <div class="table_container">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="380"
        stripe
        id="printTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        ref="table"
      >
        <el-table-column type="selection" width="35" align="center">
        </el-table-column>
        <el-table-column label="名称" min-width="200px" align="left">
          <template slot-scope="scope">
            <span class="tag tag2" v-if="scope.row.orderSend">已生成</span>
            {{ scope.row.productName }}
          </template>
        </el-table-column>
        <el-table-column
          label="货物类型"
          prop="goodName"
          width="140px"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              <span class="tag" v-if="scope.row.goodType == 1">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              {{ scope.row.goodName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="派送点"
          prop="deliveryTitle"
          width="120px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.deliveryTitle }}
          </template>
        </el-table-column>
        <el-table-column
          label="客户"
          prop="userName"
          min-width="70px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
        <el-table-column label="vip号" min-width="80px" align="center">
          <template slot-scope="scope">
            {{ scope.row.vipCode }}
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" width="180px">
          <template slot-scope="scope">
            <span
              class="boxTag"
              v-if="scope.row.isDelivery"
            >
              {{ scope.row.isDelivery ? "派" : "" }}
            </span>
            {{ scope.row.expressNo }}
          </template>
        </el-table-column>
        <el-table-column label="批次" align="center" width="160px">
          <template slot-scope="scope">
            {{ scope.row.batchNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="物流公司"
          prop="expressCompany"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="运单号"
          prop="expressNo"
          min-width="125px"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.expressNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="商品价值"
          prop="predictTotal"
          min-width="60px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="体积"
          prop="productVolume"
          min-width="80px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="重量"
          prop="productWeight"
          min-width="60px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="尺寸"
          prop="measure"
          min-width="90px"
          align="center"
        >
        </el-table-column>
        <el-table-column label="状态" width="90px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1" style="color: #d9001b">
              待入库
            </div>
            <div v-else-if="scope.row.status == 2" style="color: #f59a23">
              已入库
            </div>
            <div v-else-if="scope.row.status == 3" style="color: #70b603">
              已出库
            </div>
            <div v-else-if="scope.row.status == 4" style="color: #70b603">
              已结单
            </div>
            <div v-else-if="scope.row.status == -1" style="color: gray">
              已取消
            </div>
            <div v-else-if="scope.row.status == 7" style="color: #f59a23">
              （中心仓）已入库
            </div>
            <div v-else-if="scope.row.status == 8" style="color: #70b603">
              （中心仓）已出库
            </div>
            <div v-else-if="scope.row.status == 9" style="color: #f59a23">
              （派送）已入库
            </div>
            <div v-else-if="scope.row.status == 10" style="color: #ffa500">
              可预约
            </div>
            <div v-else-if="scope.row.status == 11" style="color: #008000">
              已预约
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="运费"
          min-width="70px"
          align="center"
          prop="total"
        >
          <template slot-scope="scope">
            {{ scope.row.total | priceFilt }}
          </template>
        </el-table-column>

        <el-table-column
          label="工单费（CAD）"
          min-width="140px"
          align="center"
          prop="demandMoney"
        >
        </el-table-column>
        <el-table-column
          label="派送费(CAD)"
          min-width="140px"
          align="center"
          prop="deliveryAmount"
        >
        </el-table-column>
        <el-table-column
          label="额外费用（CAD）"
          min-width="160px"
          align="center"
          prop="extraPrice"
        >
        </el-table-column>
        <el-table-column
          label="额外费用备注"
          min-width="140px"
          align="center"
          prop="extraPriceRemark"
        >
        </el-table-column>

        <el-table-column label="入库时间" width="100px" align="center">
          <template slot-scope="scope">
            {{ format(scope.row.deliveryTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="下单时间"
          width="100px"
          align="center"
          prop="addDate"
        >
        </el-table-column>
        <el-table-column
          label="箱编号"
          min-width="90px"
          align="center"
          prop="boxNumber"
        >
        </el-table-column>
        <el-table-column
          label="货柜号"
          min-width="90px"
          align="center"
          prop="containerName"
        >
        </el-table-column>
        <el-table-column
          label="签收状态"
          prop="isReceipt"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.isReceipt ? "已签收" : "未签收" }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="90px"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="outHandler(scope.row)"
              v-if="
                scope.row.status == 9 ||
                scope.row.status == 10 ||
                scope.row.status == 11
              "
              >出库结算</el-button
            >
            <el-button
              type="text"
              @click="viewHandler(scope.row)"
              v-if="scope.row.status == 4"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="footer">
        <div class="footer_pagination">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-if="activeName == 9 && accountObj.roleId == 1">
      <el-button type="primary" size="small" @click="mulOutStoreToPay()"
        >批量出库结算</el-button
      >
    </div>

    <!-- 出库结算 -->
    <el-dialog
      :visible.sync="viewDialog.show"
      :title="viewDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1000px"
      center
    >
      <div class="order_main">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label" v-if="viewDialog.orderInfo.sendNo"
              >发货单号：</span
            >
            <span class="l_label" v-else-if="viewDialog.orderInfo.orderNo"
              >订单号：</span
            >
            <span class="l_value">{{
              viewDialog.orderInfo.sendNo
                ? viewDialog.orderInfo.sendNo
                : viewDialog.orderInfo.orderNo
            }}</span>

            <span class="l_label">VIP号：</span>
            <span class="l_value">{{
              user.vipCode ? user.vipCode : viewDialog.orderInfo.vipCode
            }}</span>
            <span class="l_label">客户：</span>
            <span class="l_value">{{
              user.realName ? user.realName : viewDialog.orderInfo.realName
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">订单状态：</span
            ><span class="l_value" style="color: #20b2aa">已入库</span>
            <span class="l_label">入库时间：</span
            ><span class="l_value">{{
              viewDialog.orderInfo.deliveryEnterTime
                ? toDate(
                    viewDialog.orderInfo.deliveryEnterTime,
                    "yyyy-MM-dd hh:mm:ss"
                  )
                : toDate(
                    viewDialog.orderInfo.operatorTime,
                    "yyyy-MM-dd hh:mm:ss"
                  )
            }}</span>
            <span class="l_label">订单数量：</span
            ><span class="l_value">{{
              viewDialog.orderInfo.orderCount
                ? viewDialog.orderInfo.orderCount
                : viewDialog.orderInfo.detailList.length
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">所需总运费：</span
            ><span class="l_value"
              >CAD
              {{
                viewDialog.orderInfo ? viewDialog.orderInfo.totalFreight : 0
              }}</span
            >
            <span class="l_label">所需总工单费用：</span
            ><span class="l_value"
              >CAD
              {{
                viewDialog.orderInfo
                  ? viewDialog.orderInfo.totalWorkOrderFee
                  : 0
              }}</span
            >
            <span class="l_label">额外费用：</span
            ><span class="l_value"
              >CAD
              {{
                viewDialog.orderInfo ? viewDialog.orderInfo.extraPrice : 0
              }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">所需总费用：</span
            ><span class="l_value"
              >CAD
              {{
                viewDialog.orderInfo ? viewDialog.orderInfo.totalCost : 0
              }}</span
            >
            <span class="l_label">账户余额：</span
            ><span class="l_value"
              >CAD
              <span style="color: #daa520">{{
                user.balance ? user.balance : viewDialog.orderInfo.balance
              }}</span></span
            >
          </div>
        </div>
        <div class="order_detail">
          <div style="text-align: center">
            <span style="font-weight: bolder; font-size: 16px">订单清单</span>
          </div>
          <div class="product_list">
            <el-table :data="viewDialog.list" style="width: 100%">
              <el-table-column type="index" label="#" align="center">
              </el-table-column>
              <el-table-column prop="productName" align="center" label="物品">
              </el-table-column>
              <el-table-column label="运单号" align="center">
                <template slot-scope="scope">
                  {{
                    scope.row.expressNo
                      ? scope.row.expressNo
                      : viewDialog.orderInfo.expressNo
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="productNum" align="center" label="数量">
              </el-table-column>
              <el-table-column align="center" label="货运类型">
                <template slot-scope="scope">
                  {{
                    scope.row.goodType
                      ? goodTypeName(scope.row.goodType)
                      : goodTypeName(viewDialog.orderInfo.goodType)
                  }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="用户">
                <div>
                  {{
                    user.realName
                      ? user.realName
                      : viewDialog.orderInfo.realName
                  }}
                </div>
              </el-table-column>
              <el-table-column align="center" label="运费（CAD）">
                <template slot-scope="scope">
                  {{
                    scope.row.total
                      ? scope.row.total
                      : viewDialog.orderInfo.total
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="demandMoney"
                align="center"
                label="工费（CAD）"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.demandMoney
                      ? scope.row.demandMoney
                      : viewDialog.orderInfo.totalWorkOrderFee
                  }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-popconfirm
          title="您确定结算吗？"
          @confirm="submit"
          @onConfirm="submit"
        >
          <el-button slot="reference" type="primary" style="margin-right: 20px"
            >确定结算</el-button
          >
        </el-popconfirm>
        <el-button @click="viewDialog.show = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 预约提示对话框 -->
    <el-dialog
      :visible.sync="bookTip"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      center
    >
      <div style="font-size: 15px">确定确认吗？</div>
      <div style="font-size: 15px">
        点击确定将会将已入库但未提醒的订单打开预约通道
      </div>
      <template #footer>
        <span class="warningDia-footer">
          <el-button type="primary" @click="setReservation">确 定</el-button>
          <el-button @click="bookTip = false">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--查看详情 -->
    <el-dialog
      :visible.sync="detailDialog.show"
      :title="detailDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="600px"
      center
    >
      <div class="order_contaner">
        <div class="order_base">
          <div class="l_item">
            <span class="l_label">订单号：</span>
            <span class="l_value">{{ detailDialog.orderInfo.orderNo }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">下单时间：</span>
            <span class="l_value">{{
              toDate(detailDialog.orderInfo.addTime, "yyyy-MM-dd hh:mm:ss")
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">客户名称：</span>
            <span class="l_value">{{ detailDialog.orderInfo.userName }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">客户电话：</span>
            <span class="l_value">{{ detailDialog.orderInfo.userTel }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">客户vip：</span>
            <span class="l_value">{{ detailDialog.orderInfo.vipCode }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">快递公司：</span>
            <span class="l_value">{{
              detailDialog.orderInfo.expressCompany
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">商品价值：</span>
            <span class="l_value">{{
              detailDialog.orderInfo.predictTotal
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">订单状态：</span>
            <span :class="'l_value status' + detailDialog.orderInfo.status">{{
              orderStatus(detailDialog.orderInfo.status)
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">箱编号：</span>
            <span class="'l_value">{{ detailDialog.orderInfo.boxNumber }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">货柜号：</span>
            <span class="'l_value">{{
              detailDialog.orderInfo.containerName
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">入库时间：</span>
            <span class="l_value">{{
              detailDialog.orderInfo.storeTime
                ? toDate(
                    detailDialog.orderInfo.storeTime,
                    "yyyy-MM-dd hh:mm:ss"
                  )
                : ""
            }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">实际尺寸：</span>
            <span class="l_value"
              >{{ detailDialog.orderInfo.productLong }}CM*{{
                detailDialog.orderInfo.width
              }}CM*{{ detailDialog.orderInfo.height }}CM</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">实际重量：</span>
            <span class="l_value"
              >{{ detailDialog.orderInfo.productWeight }} KG</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">运费：</span>
            <span class="l_value">CAD {{ detailDialog.orderInfo.total }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">工单费（CAD）：</span>
            <span class="l_value"
              >CAD {{ detailDialog.feeInfo.demandMoney }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">派送费(CAD)：</span>
            <span class="l_value"
              >CAD {{ detailDialog.feeInfo.deliveryAmount }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">额外费用(CAD)：</span>
            <span class="l_value"
              >CAD {{ detailDialog.feeInfo.extraPrice }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">额外费用备注：</span>
            <span class="l_value"
              >CAD {{ detailDialog.feeInfo.extraPriceRemark }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">最后总费用：</span>
            <span class="l_value"
              >CAD {{ detailDialog.orderInfo.totalPrice }}</span
            >
          </div>
          <div class="l_item">
            <span class="l_label">订单备注：</span>
            <span class="l_value">{{ detailDialog.orderInfo.remark }}</span>
          </div>
          <div class="l_item">
            <span class="l_label">用户备注：</span>
            <span class="l_value">{{ detailDialog.orderInfo.userRemark }}</span>
          </div>
        </div>
        <div class="order_detail">
          <div class="product_list">
            <el-table
              :data="detailDialog.list"
              border
              style="width: 100%"
              stripe
            >
              <el-table-column label="名称" width="180px" align="left">
                <template slot-scope="scope">
                  {{ scope.row.productName }}
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                prop="productNum"
                width="70px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.productNum }}
                </template>
              </el-table-column>
              <el-table-column
                label="货架"
                prop="shelves"
                width="80px"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.shelves }}
                </template>
              </el-table-column>
              <el-table-column
                label="图片"
                prop="pic"
                min-width="80px"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.pic">
                    <a
                      :href="detailDialog.orderInfo.httpUrl + item"
                      target="_blank"
                      v-for="(item, index) in scope.row.pic.split(',')"
                      :key="index"
                    >
                      <img
                        :src="detailDialog.orderInfo.httpUrl + item"
                        class="d_pic"
                      />
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.show = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as date from "utils/date";
import * as order from "@/api/order";
import * as book from "../../api/book";
import * as boxApi from "@/api/box";
import * as StringUtils from "@/utils/StringUtils";
export default {
  data() {
    return {
      activeName: "9",
      search: {
        goodType: null,
        orderNo: null,
        userName: null,
        addressId: null,
        statementStartDate: null,
        deliveryEndDate: null,
        orderNumber: null,
        batchNum: null,
        // extraFee:null
      },
      tableData: [],
      expressNo: "",
      viewDialog: {
        show: false,
        title: "出库结算",
        orderId: null,
        orderInfo: {
          detailList: [],
        },
        list: [],
      },
      user: [],
      bool: false,
      columns: [
        { title: "订单编号", key: "orderNo" },
        { title: "名称", key: "productName" },
        { title: "派送点", key: "deliveryTitle" },
        { title: "货物类型", key: "goodName" },
        { title: "客户", key: "userName" },
        { title: "vip号", key: "vipCode" },
        { title: "联系方式", key: "userTel" },
        { title: "批次", key: "batchNumber" },
        { title: "箱号", key: "boxNumber" },
        { title: "物流公司", key: "expressCompany" },
        { title: "运单号", key: "expressNo" },
        { title: "商品价值", key: "predictTotal" },
        { title: "体积", key: "productVolume" },
        { title: "重量", key: "productWeight" },
        { title: "尺寸", key: "measure" },
        { title: "状态", key: "dealStatus" },
        { title: "运费", key: "total" },
        { title: "工单费(CAD)", key: "demandMoney" },
        { title: "派送费(CAD)", key: "deliveryAmount" },
        { title: "额外费用(CAD)", key: "extraPrice" },
        { title: "额外费用备注", key: "extraPriceRemark" },
        { title: "下单时间", key: "addDate" },
        { title: "所在箱", key: "boxNumber" },
        // { title: "合箱状态", key: "boxStatus" },
        { title: "用户备注", key: "userRemark" },
        { title: "订单备注", key: "remark" },
      ],
      bookTip: false,
      detailDialog: {
        show: false,
        title: "查看详情",
        orderNo: null,
        orderInfo: {},
        list: [],
        feeInfo: {},
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      postCount: 0,
      excelList: [],
      excelList2: [],
      newDate: "",

      chukuTime: null,
      totalFee: "",
      totalNum: "",

      // 当前登录账号信息
      accountObj: null,
      multipleSelection: [],
      loading: false,

      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      // 已选签收状态
      checkedRecStatus: null,
      // 签收状态选项
      receOptions: [
        { value: "0", label: "未签收" },
        { value: "1", label: "已签收" },
      ],
      deliverAddress: "", // 单个配送点时候的当前派送点
      deliverAddressArr: [], // 所有配送点
    };
  },
  created() {
    let that = this;
    that.activeName = that.$route.query.activeName
      ? that.$route.query.activeName
      : that.activeName;
    let accountObj = JSON.parse(localStorage.getItem("userinfo"));
    this.accountObj = accountObj;
    this.getAdressId();
    this.getOrderList();
    this.getBatchList();
  },
  methods: {
    init() {
      this.paginations.page_index = 1;
      this.getOrderList();
    },
    getOrderList(dataA) {
      let that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: that.activeName,
        orderNo: that.search.orderNo,
        userName: that.search.userName,
        goodType: that.search.goodType ? that.search.goodType : null,
        sendTime: that.newDate ? that.newDate : "",
        deliveryStartDate: that.statementStartDate
          ? that.statementStartDate
          : "",
        deliveryEndDate: that.deliveryEndDate ? that.deliveryEndDate : "",
        orderNumber: that.search.orderNumber ? that.search.orderNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,
        // extraFee: that.search.extraFee,
      };
      order.getOrderList(data).then((res) => {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              val.storeDate = "";
              // val.status = val.status ==10?9:val.status;
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
                val.storeDate = mUtils
                  .formatDate(new Date(val.storeTime))
                  .substring(0, 10);
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils
                  .formatDate(new Date(val.deliveryTime))
                  .substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils
                  .formatDate(new Date(val.statementTime))
                  .substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
              if (
                val.detailList &&
                val.detailList.length > 0 &&
                val.detailList[0].productName.length > 20
              ) {
                if (val.detailList.length >= 2) {
                  val.productName =
                    val.detailList[0].productName.substring(0, 20) +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(
                    0,
                    20
                  );
                }
              } else {
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList.length >= 2
                ) {
                  val.productName =
                    val.detailList[0].productName +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
                // val.productName=val.detailList[0].productName
              }
            });
            that.tableData = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
            that.totalFee = res.data.data.total;
            that.totalNum = res.data.data.num;
          } else {
            that.tableData = [];
            that.paginations.total = 0;
            that.totalFee = 0;
            that.totalNum = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    getOrderListB(page, callback, pageCount) {
      let that = this;

      // const loading = this.$loading({
      //   lock: true,
      //   text: "loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // setTimeout(function () {
      //   loading.close();
      // }, 5000);
      let status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "4") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      // that.pagTotal=false
      let data = {
        pageIndex: page,
        pageSize: pageCount,
        status: that.activeName,
        orderNo: that.search.orderNo,
        userName: that.search.userName,
        goodType: that.search.goodType ? that.search.goodType : null,
        deliveryEndDate: that.deliveryEndDate ? that.deliveryEndDate : null,
        deliveryStartDate: that.statementStartDate
          ? that.statementStartDate
          : null,
        orderNumber: that.search.orderNumber ? that.search.orderNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,
      };

      order.getOrderList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              val.goodName =
                that.goodTypeName(val.goodType) + "-" + val.goodName;
              if (val.remark) {
                val.remark = val.remark;
              }
              if (val.userRemark) {
                val.userRemark = val.userRemark;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure =
                  val.productLong +
                  "*" +
                  val.productWidth +
                  "*" +
                  val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils
                .formatDate(new Date(val.addTime))
                .substring(0, 10);
              if (
                val.detailList &&
                val.detailList.length > 0 &&
                val.detailList[0].productName.length > 20
              ) {
                if (val.detailList.length >= 2) {
                  val.productName =
                    val.detailList[0].productName.substring(0, 20) +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(
                    0,
                    20
                  );
                }
              } else {
                if (
                  val.detailList &&
                  val.detailList.length > 0 &&
                  val.detailList.length >= 2
                ) {
                  val.productName =
                    val.detailList[0].productName +
                    "...等" +
                    val.detailList.length +
                    "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
                // val.productName=val.detailList[0].productName
              }
            });
            that.postCount++;
            callback(res.data.data.list, res.data.data.pageCount, page);
          } else {
            that.orderMoneyB = that.orderMoneyB;
            callback([], res.data.data.pageCount, page);
          }
        } else {
          callback();
          that.$message.error("导出订单列表失败");
        }
        // loading.close();
      });
    },
    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format(shijianchuo) {
      //shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + "-" + this.add0(m) + "-" + this.add0(d);
    },
    exportToExcel() {
      let that = this;
      let orderName = "";
      that.orderMoneyB = [];
      that.pagTotal = false;
      that.postCount = 0;
      let pageCountt = 400;
      that.excelList = [];
      that.excelList2 = [];
      let nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
      if (that.activeName == "first") {
        // that.getOrderList();
      } else if (that.activeName == "8") {
        // that.getOrderList();
        orderName = "待入库" + nowTime;
      } else if (that.activeName == "9") {
        orderName = "已入库" + nowTime;
        // that.getOrderList();
      } else if (that.activeName == "4") {
        orderName = "(派送)已出库" + nowTime;
      }

      if (that.paginations.total) {
        that.pageIndex = Math.ceil(that.paginations.total / pageCountt);

        const loading = this.$loading({
          lock: true,
          text: "loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        that.bool = false;
        for (let i = 1; i <= that.pageIndex; i++) {
          that.pageIndexB = i;
          that.getOrderListB(
            that.pageIndexB,
            function (val, pageCount, index) {
              that.excelList[index - 1] = val;
              if (i == that.pageIndex && that.bool == false) {
                for (let i = 0; i < that.excelList.length; i++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[i]);
                }
                mUtils.export2Excel(that.columns, that.excelList2, orderName);
                // res = "";
                loading.close();
                that.bool = true;
              } else if (
                pageCount <= that.orderMoneyB.length &&
                that.bool == false
              ) {
                loading.close();
                for (let i = 0; i < that.excelList.length; i++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[i]);
                }
                mUtils.export2Excel(that.columns, that.excelList2, orderName);
                that.bool = true;
              }
            },
            pageCountt
          );
        }
      }

      // setTimeout(function () {

      // }, 1000);
    },
    outHandler(row) {
      this.viewDialog.orderId = row.orderId;
      // this.viewDialog.show = true;
      this.viewDialog.orderInfo = row;
      this.viewDialog.list = [];
      this.getSettlementSheet();
      this.submit();
    },
    getSettlementSheet(id) {
      let that = this;
      let param = {};
      param.orderId = that.viewDialog.orderId;
      boxApi.settlementSheet(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取异常");
        }
        that.viewDialog.orderInfo = res.data.data;
        that.viewDialog.list = that.viewDialog.orderInfo.orderPojoList
          ? that.viewDialog.orderInfo.orderPojoList
          : that.viewDialog.orderInfo.detailList;
        that.user = res.data.data.user ? res.data.data.user : [];
      });
    },
    setReservation() {
      let that = this;
      let param = {};
      if (mUtils.getStore("userinfo")) {
        let userDetail = mUtils.getStore("userinfo");
        if (userDetail.roleId !== 1) {
          this.deliverAddress = userDetail.adminId;
          that.deliverAddressArr.forEach((dItem, index) => {
            if (dItem.adminId == this.deliverAddress) {
              param.addressId = dItem.addressId || "";
            }
          });
        }
      }

      boxApi.setReservation(param).then((res) => {
        if (res.status !== 200) return this.$message.error(res.msg);
        if (res.data.code !== 0)
          return this.$message.error(
            res.data.msg ? res.data.msg : "接口出错, 请联系工作人员"
          );
        this.getOrderList();
        return this.$message.success("预约提醒成功");
      });
      this.bookTip = false;
    },
    submit() {
      let that = this;
      let param = {};
      param.orderId = this.viewDialog.orderId;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      boxApi.confirmSettlement(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getOrderList();
        that.viewDialog.show = false;
      });
    },
    handleClick() {
      if (this.activeName == 8) {
        this.$router.push("/delivery/order?activeName=" + this.activeName);
        return;
      }
      this.search.batchNum = "";
      this.init();
    },
    viewHandler(row) {
      this.detailDialog.orderNo = row.orderNo;
      this.getOrderDetail();
      this.detailDialog.show = true;
    },
    getOrderDetail() {
      let that = this;
      let param = {};
      param.orderNo = that.detailDialog.orderNo;
      order.getOrderInfo(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取异常");
        }
        that.detailDialog.orderInfo = res.data.data;
        that.detailDialog.list = res.data.data.detailList || [];
        that.detailDialog.feeInfo = res.data.data.response || {};
      });
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodTypeName(goodType) {
      return StringUtils.goodType(goodType);
    },
    orderStatus(status) {
      return StringUtils.orderStatus(status);
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getOrderList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getOrderList();
    },
    getDate(chukuTime) {
      if (!chukuTime) {
        this.statementStartDate = "";
        this.deliveryEndDate = "";
        this.init();
        return;
      }
      this.statementStartDate = new Date(
        mUtils.formatDate(chukuTime[0])
      ).getTime();
      this.deliveryEndDate =
        new Date(mUtils.formatDate(chukuTime[1])).getTime() + 86399000;
      this.init();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 批量出库结算
    mulOutStoreToPay() {
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      let orderIds = [];
      that.multipleSelection.forEach((obj) => {
        orderIds.push(obj.orderId);
      });
      param.orderIds = orderIds;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });

      boxApi.deliverOutTopay(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getOrderList();
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.init();
    },

    batchChange() {
      this.init();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },

    //获取派送点
    getAdressId() {
      book.deliveryList({ type: 2 }).then((res) => {
        if (res.status !== 200) {
          return this.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          this.deliverAddressArr = res.data.data.list;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.warp_contrainer {
  padding: 3px 20px 50px 20px;
  margin-bottom: 50px;

  .footer {
    width: 100%;
    margin: 20px 0 50px 0;
    position: relative;
    .footer_pagination {
      position: absolute;
      right: 0;
      top: 0;
      left: 200px;
      margin-top: 0;
      text-align: right;
    }
  }
}
.totalFeeBtn {
  margin-left: 10px;
  background-color: transparent;
  .totalFee > span {
    display: inline-block;
    margin-left: 4px;
    color: green;
    font-weight: bold;
  }
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
}
.order_main {
  .order_base {
    margin-bottom: 20px;
    .l_item {
      padding: 8px 0;
      font-size: 12px;
      span {
        display: inline-block;
      }
      .l_label {
        width: 120px;
        text-align: right;
        font-weight: 600;
      }
      .l_value {
        width: 180px;
      }
    }
  }
  .order_detail {
    .title {
      padding-bottom: 10px;
      border-bottom: 1px solid #e1e1e1;
      .name {
        font-size: 15px;
        font-weight: bold;
      }
    }
    .product_list {
      margin-top: 20px;
    }
  }
}
.order_contaner {
  .order_base {
    .l_item {
      padding: 5px 0;
      font-size: 12px;
      span {
        display: inline-block;
      }
      .l_label {
        width: 120px;
        text-align: right;
        font-weight: 600;
      }
      .l_value {
        width: 180px;
      }
    }
  }
  .d_pic {
    width: 70px;
    height: 70px;
    background-size: contain;
    margin: 0 3px;
    border-radius: 3px;
  }
}

.boxTag {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 4px;
  background-color: #ffa500;
  border-color: #faecd8;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// orderList.vue?eca77a24